import { FaExclamationCircle } from 'react-icons/fa';
import { useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import axios from 'axios';
import VerifyResult from '../../component/public/VerifyResult';

const Verify = () => {
    const { id } = useParams();
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(true);
        axios
            .get(`api/loa/verify/${id}`, { withCredentials: false })
            .then((response) => setData(response.data))
            .catch(() => setData({ error: true }))
            .finally(() => setLoading(false));
    }, [id]);

    if (loading) {
        return (
            <div className="flex min-h-[50vh] items-center justify-center px-4">
                <div
                    className="h-8 w-8 animate-spin rounded-full border-2 border-hairline border-t-primary"
                    role="status"
                    aria-label="Memuat"
                />
            </div>
        );
    }

    if (data?.error) {
        return (
            <div className="mx-auto max-w-2xl px-4 py-12 sm:px-6">
                <div className="card p-10 text-center">
                    <FaExclamationCircle className="mx-auto text-5xl text-red-500" />
                    <h1 className="mt-4 text-xl font-medium text-ink dark:text-white">
                        Data tidak ditemukan
                    </h1>
                    <p className="mt-2 text-sm text-muted">
                        Tautan verifikasi tidak valid atau LOA sudah tidak tersedia.
                    </p>
                </div>
            </div>
        );
    }

    return (
        <div className="mx-auto max-w-3xl px-4 py-10 sm:px-6">
            <VerifyResult data={data} />
        </div>
    );
};

export default Verify;
